import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/requisitions'
import Component from 'components/Requisitions'

export default createListViewContainer({ actions, selectors: selectors.requisitions })(Component)
